// 랜덤코드 생성
export const generate_random_code = (n: number) => {
    let str = ''
    for (let i = 0; i < n; i++) {
      str += Math.floor(Math.random() * 10)
    }
    return str;
};

// 전화번호에 - 제거
export const eliminate_hyphen = (str: string) => {
    let words = str.split('-');
    let result = ""
    for(const tmp of words) {
        result += tmp;
    };
    return result;
};

// 전체 게시물 개수 계산해서 페이지네이션 리스트 10개씩 받아오기
export const handlePagination = (totalPages: number, listCount: number) => {
    let total = totalPages;
    let page_count = 0;

    if(total%listCount === 0) {
        page_count = Math.floor(total/listCount);
    } else {
        page_count = Math.floor(total/listCount)+1;
    };

    let list = [];
    for(let i = 1; i < page_count+1; i++) {
        list.push(i);
    };

    let result = [];
    for(let i = 0; i < list.length; i += 10) {
        let tempArray;
        tempArray = list.slice(i, i+10);
        result.push(tempArray);
    };
    return result;
};

export const search_regExp = (text: string) => {
    let result = text.toLowerCase().trim().split(' ').join('');
    return result;
}

// 로컬스토리지 update_nav_switch 변환
export const update_nav = () => {
    if(window.localStorage.getItem('update_nav_switch')) {
        let value = window.localStorage.getItem('update_nav_switch');
        let boolean = JSON.parse(String(value));
        let result_value = !boolean;
        window.localStorage.setItem('update_nav_switch', JSON.stringify(result_value));
    };
}